import React from 'react';
import { LayersIcon } from 'lucide-react';
import { brand, footerCopy } from '../data/content';
export function Footer() {
  return <footer className="w-full border-t border-blue-100 bg-white py-12 md:py-14" data-id="element-86" data-mp="3ggtz0kj4bn6a">
      <div className="mx-auto w-full max-w-4xl px-5 text-center md:px-8" data-id="element-87" data-mp="32ovvcp86ejhi">
        <p className="inline-flex items-center gap-2 text-base font-extrabold uppercase tracking-wider text-blue-600 md:text-lg md:tracking-widest" data-id="element-88" data-mp="36oxyz3xh1mzf">
          <LayersIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-89" data-mp="3uftm3nqzfu0c" />
          {brand.name}
        </p>

        <p className="mx-auto mt-5 max-w-xl text-blue-900/75" data-id="element-90" data-mp="36mu4n8jl4u2">{footerCopy.tagline}</p>

        <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-7 gap-y-3 text-blue-900/75" data-id="element-91" data-mp="3ldu8l5f6f825">
          {footerCopy.links.map(link => <li key={link.label} data-id="element-92" data-mp="29yno3sf6hjhp">
              <a href={link.href} className="transition-colors duration-150 ease-out hover:text-blue-600" data-id="element-93" data-mp="29ydrvn3jig3k">
                {link.label}
              </a>
            </li>)}
        </ul>

        <p className="mt-10 border-t border-blue-100 pt-6 text-sm text-blue-900/50" data-id="element-94" data-mp="3gagzjp259b3q">
          © 2026 {brand.name}. {footerCopy.rights}
        </p>
      </div>
    </footer>;
}